export const select = (value: any): true => true;

export default select;
